import React from "react";
import "../../css/designSystem/ClientPortalCard.css";
import { ReactComponent as ArrowIcon } from "../../assets/icons/ArrowRight.svg";

const ClientPortalCard = ({ icon: Icon, title, description, onClick }) => {
  return (
    <div className="client-portal-card" onClick={onClick}>
      <div className="client-portal-card-icon-bg">
        <Icon className="client-portal-card-icon" />
      </div>
      <div className="content-semibold grey">{title}</div>
      <div className="row">
        <div className="help-text grey">{description}</div>

        <ArrowIcon className="client-portal-card-arrow" />
      </div>
    </div>
  );
};

export default ClientPortalCard;
